// api/workbooks.js
import apiClient from "./client";

export const workbooksApi = {
  getAll: () => apiClient.get("/api/workbooks"),
  getOne: (slug) => apiClient.get(`/api/workbooks/${slug}`),
  getProgress: (slug) => apiClient.get(`/api/progress/${slug}`),
  saveProgress: (data) => apiClient.post("/api/progress", data),
  checkAccess: (slug) => apiClient.get(`/api/payment/access/${slug}`),
  // Removed: getPricing. /api/pricing still answers as a deprecated shim for
  // browsers running the previous bundle, but nothing in this app calls it any
  // more. Prices come from the catalogue: see api/catalogue.js.
  getReviewSummary: (workbookId) => apiClient.get(`/api/reviews/${workbookId}`),
  getMarquee: () => apiClient.get("/api/reviews/marquee"),
  // createOrder is authRequired: there is nothing to do without a session, and
  // no money has moved yet, so login is the right place to be sent.
  createOrder: (data) =>
    apiClient.post("/api/payment/create-order", data, { authRequired: true }),
  // verifyPayment deliberately is NOT authRequired. By the time this runs the
  // card has been charged, and Razorpay has confirmed the order to the webhook
  // independently, so the purchase is safe whatever this call returns. Yanking
  // the buyer to a login screen at that exact moment reads as "your payment
  // failed". It fails in place instead: see the 401 branch in
  // api/payment.js, which tells them the payment landed.
  verifyPayment: (data) => apiClient.post("/api/payment/verify", data),
};
